import { useTranslation } from "react-i18next";
import styles from "./css/MoreButton.module.css";
import { ReactComponent as MoreIcon } from "../../img/iconImgAllMore.svg";

interface MoreButtonProps {
  color?: string;
  onClick: (e: React.MouseEvent<HTMLDivElement>) => void;
}

export default function MoreButton(props: MoreButtonProps) {
  const { t } = useTranslation();
  function handleOnClickButton(e: React.MouseEvent<HTMLButtonElement>) {
    e.stopPropagation();
    // 마우스로 누른 경우 포커스를 풀어, 학습 화면의 Enter 단축키가 이 버튼을 다시 누르지 않게 한다
    if (e.detail > 0) e.currentTarget.blur();
    props.onClick(e as unknown as React.MouseEvent<HTMLDivElement>);
  }

  return (
    <>
      <button
        type="button"
        className={styles.button}
        aria-label={t("MoreMenu")}
        onClick={handleOnClickButton}
        style={{
          color: props.color ?? "var(--icon-secondary-color)",
        }}
      >
        <MoreIcon
          className={styles.icon}
          style={{
            width: "24px",
            height: "24px",
          }}
        />
      </button>
    </>
  );
}
